/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React from "react";
import styles from "./Shimmer.module.css";
import cx from "classnames";

// Shimmer animation
const Shimmer = () => {
  return (
    <div className={cx(styles.Card, styles.Br)}>
      <div className={styles.Wrapper}>
        <div className={cx(styles.ProfilePic, styles.Animate)}></div>
        <div>
          <div
            className={cx(
              styles.Comment,
              styles.Br,
              styles.Animate,
              styles.W80
            )}></div>
          <div className={cx(styles.Comment, styles.Br, styles.Animate)}></div>
          <div className={cx(styles.Comment, styles.Br, styles.Animate)}></div>
        </div>
      </div>
    </div>
  );
};

export default Shimmer;
